import { useTranslation } from 'react-i18next';
import AlertBox from '@/components/alert-box';
import { formatDateTimeWithLocale } from '@/utils/utils';
import { lawWarningAckText } from './lawWarningAckText';

/**
 * Warnings that were confirmed with "Submit / Approve / Delete anyway" on a
 * request: what the warning said, who confirmed it, when, and the reason.
 */
export default function LawWarningsAcknowledged({ acks = [] }) {
  const { t } = useTranslation(['forms']);
  const items = (acks || []).filter(Boolean);
  if (!items.length) return null;

  return (
    <AlertBox variant="warning" className="mb-0 p-3 text-left">
      <div className="grid gap-3">
        <h4 className="font-semibold text-black">
          {t('lawWarningsAckTitle', { ns: 'forms' })}
        </h4>
        {items.map((ack, i) => {
          const what = lawWarningAckText(ack, t);
          const when = ack.acknowledgedAt
            ? formatDateTimeWithLocale(ack.acknowledgedAt, undefined, true)
            : '';
          return (
            <div key={i} className="grid gap-1 text-sm">
              <p className="text-zinc-700">{what}</p>
              {/* Entries from before the reason became mandatory have none. */}
              {ack.reason && (
                <p>
                  <span className="font-semibold">
                    {t('lawWarningsAckReason', { ns: 'forms' })}:
                  </span>{' '}
                  {ack.reason}
                </p>
              )}
              {(ack.acknowledgedByName || when) && (
                <p className="text-xs text-zinc-500">
                  {[ack.acknowledgedByName, when].filter(Boolean).join(' · ')}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </AlertBox>
  );
}
